import classNames from 'classnames';
import React from 'react';
import {EditableComponentProps, useEditableComponent} from './editableComponent';

export default function EditableList(props: EditableComponentProps) {
    const {textKey, className} = props;
    const [content, onChange, editable] = useEditableComponent(textKey);

    return (
        <ul contentEditable={editable} className={classNames('editable-component', 'editable-list', className)}
            onInput={onChange} dangerouslySetInnerHTML={{__html: content}}/>
    );
}

EditableList.displayName = 'EditableList';